import { Box, styled } from "@mui/material";
import { useRouteError } from "react-router-dom";
import pantalla404 from '../img/Pantalla-404.png';
import pantallaErrorInesperado from '../img/Pantalla-error-inesperado.png';

export const ErrorBox = styled(Box)(({ theme }) => ({
  display: "flex", 
  justifyContent: "center", 
  flexDirection: "column", 
  alignItems: "center"
}));

export const SurveyBackground = styled('div')(({ theme }) => ({
    width: '100vw',
    minHeight: '100vh',
    height: 'fit-content',
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column"
  }));

export default function ErrorPage() {
  const error = useRouteError();

  return (
    <SurveyBackground 
        style={{ 
          backgroundImage: `url(${error.status === 404 ? pantalla404 : pantallaErrorInesperado})`, 
          backgroundRepeat: 'no-repeat', 
          backgroundSize: "cover", 
          backgroundPosition: "center" }}>
        
    </SurveyBackground>
  );
};
